const numberFormatter = new Intl.NumberFormat('en-US');
const wholeNumberFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
const compactNumberFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 0,
});
const pluralRules = new Intl.PluralRules('en-US');
const WHOLE_NUMBER_TEXT_PATTERN = /^\d*$/;
const LEADING_ZEROS_PATTERN = /^0+(?=\d)/;

export function formatNumber(value: number | null | undefined): string {
  return numberFormatter.format(value ?? 0);
}

export function formatWholeNumber(value: number | null | undefined): string {
  return wholeNumberFormatter.format(value ?? 0);
}

export function formatCompactNumber(value: number): string {
  return compactNumberFormatter.format(value);
}

export function parseNumberText(text: string): number | undefined {
  if (text.trim() === '') return undefined;
  const parsed = Number(text);
  return Number.isFinite(parsed) ? parsed : undefined;
}

export function normalizeWholeNumberText(text: string): string | undefined {
  if (!WHOLE_NUMBER_TEXT_PATTERN.test(text)) return undefined;
  return text.replace(LEADING_ZEROS_PATTERN, '');
}

export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return pluralRules.select(count) === 'one' ? singular : plural;
}

export function formatCount(count: number, singular: string): string {
  return `${count} ${pluralize(count, singular)}`;
}
